// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Ma9i","title":"_1RpFZ","comments":"_1gNlM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SupportMessage/SupportMessage.scss
// module id = ./src/components/SupportMessage/SupportMessage.scss
// module chunks = 5